export const APP_NAME = "Archery Scorekeeper";
